import { BrandType } from "@bus/models";

export const capitalizeBrand = (str: BrandType) => {
    if (!str) return str;
    if(str.toLowerCase() === BrandType.SEAT || str.toLowerCase() === BrandType.CUPRA){
      return str.toUpperCase();
    }
    if(str.toLowerCase() === BrandType.SKODA){
      return "Škoda";
    }
    if(str.toLowerCase() === BrandType.VW){
      return "Volkswagen";
    }
    const result = str.toLowerCase();
    return `${result.charAt(0).toUpperCase()}${result.slice(1)}`;
  }